import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthApi } from 'sham-components/services';
import {
  RequestOtpPayload,
  VerifyPasswordResetOtpPayload,
} from 'sham-components/shared/models/auth';

@Injectable()
export class RequestPasswordResetManager {
  private readonly authApi = inject(AuthApi);

  async requestOtp(payload: RequestOtpPayload, submitError: any, loading: any) {
    try {
      await firstValueFrom(this.authApi.requestPasswordResetOtp(payload));
    } catch {
      submitError.set('Unable to send OTP code. Please try again.');
    } finally {
      loading.set(false);
    }
  }

  async verifyOtp(
    payload: VerifyPasswordResetOtpPayload,
    submitError: any,
    loading: any,
  ): Promise<string | null> {
    try {
      const result = await firstValueFrom(
        this.authApi.verifyPasswordResetOtp(payload),
      );

      return result.resetToken;
    } catch {
      submitError.set('Invalid OTP code. Please try again.');
      return null;
    } finally {
      loading.set(false);
    }
  }
}
